import { Box, Chip, Tab, Tabs } from "@mui/material";
import { alpha } from "@mui/material/styles";
import React from "react";

import { monospaceStyle } from "../../theme";
import { ExploreTab } from "./exploreTabs";

interface ExploreTabsProps {
  tabs: ExploreTab[];
  // The type of the tab shown
  current: string;
  // The number shown on the current tab; none while it is not known
  count?: number;
}

// The tabs of Explore by entity type. An inactive tab is shown and cannot
// be chosen. The chosen tab reads in the text colour over an accent line.
const ExploreTabs: React.FC<ExploreTabsProps> = ({ tabs, current, count }) => (
  <Tabs
    value={current}
    aria-label="Entity types"
    sx={{
      minHeight: 40,
      "& .MuiTabs-indicator": { backgroundColor: "accent.main" },
    }}
  >
    {tabs.map((tab) => (
      <Tab
        key={tab.type}
        value={tab.type}
        disabled={!tab.active}
        sx={{
          minHeight: 40,
          fontSize: "0.8125rem",
          textTransform: "none",
          "&.Mui-selected": { color: "text.primary" },
        }}
        label={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {tab.label}
            {tab.type === current && count !== undefined && (
              <Chip
                label={count.toLocaleString("en-US")}
                size="small"
                sx={{
                  ...monospaceStyle,
                  height: 20,
                  fontSize: "0.75rem",
                  color: "link.main",
                  backgroundColor: (theme) =>
                    alpha(theme.palette.link.main, 0.12),
                }}
              />
            )}
          </Box>
        }
      />
    ))}
  </Tabs>
);

export default ExploreTabs;
